import { SocketEvent } from "../SocketEvent";
import { SocketEventInterface } from "../SocketEventInterface";
import { SocketEventProcessorInterface } from "../SocketEventProcessorInterface";
import Constants from "../../Action/Constants";
import TransactionFileFactory from "../../Entity/Factories/TransactionFileFactory";
import { TransactionFileInterface } from "../../Entity/Entities/TransactionFile/TransactionFileInterface";

class TransactionFileCreate extends SocketEvent implements SocketEventInterface {

  protected props: any;

  constructor() {
    super();
  }

  public process(props: SocketEventProcessorInterface): void {
    const transactionFile: TransactionFileInterface = TransactionFileFactory.create(props.res);

    this.props.dispatch({
      type: Constants.GLOBAL_TRANSACTION_FILE_CREATE_SUCCESS,
      payload: {
        transactionFile: transactionFile
      }
    });
  }

}

export { TransactionFileCreate };
